export default "__VITE_ASSET__D8x4KppD__"